/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { TimeZoneSettings } from '../types';
// @ts-ignore
import type { UpdateTimeZoneSettingsUpdateBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * TimeZoneSettingsApi - axios parameter creator
 * @export
 */
export const TimeZoneSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns TimeZoneSettings for a Dashboard.
         * @summary Get TimeZoneSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeZoneSettingsForDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getTimeZoneSettingsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/time_zone_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates TimeZoneSettings.
         * @summary Update TimeZoneSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateTimeZoneSettingsUpdateBody} [updateTimeZoneSettingsUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeZoneSettings: async (dashboardId: string, updateTimeZoneSettingsUpdateBody?: UpdateTimeZoneSettingsUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateTimeZoneSettings', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/time_zone_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTimeZoneSettingsUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeZoneSettingsApi - functional programming interface
 * @export
 */
export const TimeZoneSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeZoneSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns TimeZoneSettings for a Dashboard.
         * @summary Get TimeZoneSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeZoneSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeZoneSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeZoneSettingsForDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeZoneSettingsApi.getTimeZoneSettingsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates TimeZoneSettings.
         * @summary Update TimeZoneSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateTimeZoneSettingsUpdateBody} [updateTimeZoneSettingsUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimeZoneSettings(dashboardId: string, updateTimeZoneSettingsUpdateBody?: UpdateTimeZoneSettingsUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeZoneSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimeZoneSettings(dashboardId, updateTimeZoneSettingsUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeZoneSettingsApi.updateTimeZoneSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TimeZoneSettingsApi - factory interface
 * @export
 */
export const TimeZoneSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeZoneSettingsApiFp(configuration)
    return {
        /**
         * Returns TimeZoneSettings for a Dashboard.
         * @summary Get TimeZoneSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeZoneSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<TimeZoneSettings> {
            return localVarFp.getTimeZoneSettingsForDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates TimeZoneSettings.
         * @summary Update TimeZoneSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateTimeZoneSettingsUpdateBody} [updateTimeZoneSettingsUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeZoneSettings(dashboardId: string, updateTimeZoneSettingsUpdateBody?: UpdateTimeZoneSettingsUpdateBody, options?: RawAxiosRequestConfig): AxiosPromise<TimeZoneSettings> {
            return localVarFp.updateTimeZoneSettings(dashboardId, updateTimeZoneSettingsUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeZoneSettingsApi - object-oriented interface
 * @export
 * @class TimeZoneSettingsApi
 * @extends {BaseAPI}
 */
export class TimeZoneSettingsApi extends BaseAPI {
    /**
     * Returns TimeZoneSettings for a Dashboard.
     * @summary Get TimeZoneSettings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeZoneSettingsApi
     */
    public getTimeZoneSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return TimeZoneSettingsApiFp(this.configuration).getTimeZoneSettingsForDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates TimeZoneSettings.
     * @summary Update TimeZoneSettings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {UpdateTimeZoneSettingsUpdateBody} [updateTimeZoneSettingsUpdateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeZoneSettingsApi
     */
    public updateTimeZoneSettings(dashboardId: string, updateTimeZoneSettingsUpdateBody?: UpdateTimeZoneSettingsUpdateBody, options?: RawAxiosRequestConfig) {
        return TimeZoneSettingsApiFp(this.configuration).updateTimeZoneSettings(dashboardId, updateTimeZoneSettingsUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}

